import { IReduxAction } from '~/services/interfaces/common-interface';
import {
  SET_LOADING_DATA,
  SET_PAGE,
  SET_ROWS_PER_PAGE,
  SET_ROWS_COUNT,
  SET_ROWS_ORIENTATION,
  SET_ORDER,
  SET_ORDERBY,
  GET_ALL_SUCCESS,
  GET_FILTER_SUCCESS,
  SEARCH,
  GET_ALL_SELECTS_SUCCESS,
  SET_LOADING_SELECTS
} from './ratings-constants';

const INITIAL_STATE = {
  loadingData: false,
  loadingSelects: true,
  list: {
    hasRemotePagination: true,
    allRows: [],
    rows: [],
    rowsCount: 0,
    page: 0,
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 25, 50, 100],
    selects: {},
    order: 'asc',
    orderBy: 'createdAt'
  }
};

const productReducer = (state: any = { ...INITIAL_STATE }, action: IReduxAction) => {
  switch (action.type) {
    case SET_LOADING_DATA: {
      return {
        ...state,
        loadingData: action.loading
      };
    }

    case SET_LOADING_SELECTS: {
      return {
        ...state,
        loadingSelects: action.loading
      };
    }

    case GET_FILTER_SUCCESS: {
      return {
        ...state,
        list: {
          ...state.list,
          rows: action.products,
          allRows: action.products,
          rowsCount: action.rowsCount ?? state?.list?.rowsCount
        }
      };
    }

    case GET_ALL_SUCCESS: {
      return {
        ...state,
        list: {
          ...state.list,
          rows: [...action.payload.rows],
          selects: {
            ...state.list.selects,
            vendors: action.payload?.selects?.vendors,
            clients: action.payload?.selects?.clients
          },
          rowsCount: action.payload.rowsCount ?? state?.list?.rowsCount
        }
      };
    }

    case GET_ALL_SELECTS_SUCCESS: {
      return {
        ...state,
        list: {
          ...state.list,
          selects: {
            ...state.list.selects,
            clients: action.payload?.selects?.clients,
            vendors: action.payload?.selects?.vendors
          }
        }
      };
    }

    case SET_PAGE: {
      return {
        ...state,
        list: {
          ...state.list,
          page: action.page
        }
      };
    }

    case SET_ROWS_PER_PAGE: {
      return {
        ...state,
        list: {
          ...state.list,
          rowsPerPage: action.rowsPerPage
        }
      };
    }

    case SET_ROWS_COUNT: {
      return {
        ...state,
        list: {
          ...state.list,
          rowsCount: action.rowsCount
        }
      };
    }

    case SET_ROWS_ORIENTATION: {
      return {
        ...state,
        list: {
          ...state.list,
          rowsOrientation: action.rowsOrientation
        }
      };
    }

    case SET_ORDER: {
      return {
        ...state,
        list: {
          ...state.list,
          order: action.order
        }
      };
    }

    case SET_ORDERBY: {
      return {
        ...state,
        list: {
          ...state.list,
          orderBy: action.orderBy
        }
      };
    }

    case SEARCH: {
      const { queryString } = action;

      const results =
        queryString !== ''
          ? state.list.allRows.filter(
              (item: any) =>
                item?.name?.toLowerCase().startsWith(queryString.toLowerCase()) ||
                item?.barCode?.toLowerCase().startsWith(queryString.toLowerCase()) ||
                item?.brand?.toLowerCase().startsWith(queryString.toLowerCase()) ||
                item?.stock?.availableQuantity?.toString().startsWith(queryString)
            )
          : state.list.allRows;

      return {
        ...state,
        list: {
          ...state.list,
          rows: [...results]
        }
      };
    }

    default:
      return state;
  }
};

export default productReducer;
